import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/base.css";
import "./styles/workshop.css";
import "./styles/lab-chooser.css";
import "./styles/lab-chrome.css";
import "./styles/lab-dawn.css";
import "./styles/lab-pocket.css";
import "./styles/lab-lamp.css";
import "./styles/app.css";

const root = document.getElementById("root");
if (root) {
  const labSsr = Boolean(root.querySelector("[data-lab-ssr]"));
  if (root.childNodes.length && !labSsr) hydrateRoot(root, <App />);
  else createRoot(root).render(<App />);
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
